const BD_COLOR_MAP = {
  "Noir":        "#000000",
  "Gris":        "#808080",
  "Vert Paon":   "#00869a",
  "Beige":       "#ead8ab",
  "Bleu Marine": "#1f3554",
  "Rose":        "#f06ca1",
  "Bleu":        "#30c1e6",
  "Violet clair":"#c9d6e4"
};

function initBdSwatches() {
  // On cible uniquement les selects de couleur (option-index="1")
  document.querySelectorAll('.bd-variant-select[data-option-index="1"]').forEach(select => {
    if (select.dataset.swatchDone) return;
    select.dataset.swatchDone = "true";

    // Créer le conteneur de swatches
    const wrapper = document.createElement('div');
    wrapper.className = 'bd-swatch-wrapper';

    Array.from(select.options).forEach(option => {
      const color = BD_COLOR_MAP[option.value];
      if (!color) return;

      const swatch = document.createElement('span');
      swatch.className = 'bd-swatch';
      swatch.style.backgroundColor = color;
      swatch.dataset.value = option.value;
      swatch.title = option.value;

      if (option.selected) swatch.classList.add('bd-swatch--active');

      swatch.addEventListener('click', () => {
        select.value = option.value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
        wrapper.querySelectorAll('.bd-swatch').forEach(s => s.classList.remove('bd-swatch--active'));
        swatch.classList.add('bd-swatch--active');
      });

      wrapper.appendChild(swatch);
    });

    // Cacher le select, insérer les swatches
    select.style.display = 'none';
    select.parentNode.insertBefore(wrapper, select);
  });
}

// Init au chargement + observer pour les bundles chargés dynamiquement
document.addEventListener('DOMContentLoaded', () => {
  initBdSwatches();
  const observer = new MutationObserver(initBdSwatches);
  observer.observe(document.body, { childList: true, subtree: true });
});
